const REPORTS_KEY = "wl_bs_accounting_reports_extras";
const ACCOUNTED_KEY = "wl_bs_accounting_accounted_earnings";

function readJson(key, fallback) {
  if (typeof sessionStorage === "undefined") {
    return fallback;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (raw == null) {
      return fallback;
    }
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // no-op
  }
}

export function clearDemoAccountingSessionStorage() {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(REPORTS_KEY);
  sessionStorage.removeItem(ACCOUNTED_KEY);
}

export function getDemoAccountingReportRows() {
  const rows = readJson(REPORTS_KEY, []);
  return Array.isArray(rows) ? rows : [];
}

export function upsertDemoAccountingReport(row) {
  if (!row || row.id == null) {
    return;
  }
  const sid = String(row.id);
  const rows = getDemoAccountingReportRows();
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    rows[idx] = { ...rows[idx], ...row };
  } else {
    rows.push(row);
  }
  writeJson(REPORTS_KEY, rows);
}

export function getAccountedEarningsKeys() {
  const keys = readJson(ACCOUNTED_KEY, []);
  return Array.isArray(keys) ? keys.map(String) : [];
}

export function markAccountedEarnings(keys) {
  const incoming = (keys || []).map(String).filter(Boolean);
  if (!incoming.length) {
    return;
  }
  const merged = Array.from(new Set([...getAccountedEarningsKeys(), ...incoming]));
  writeJson(ACCOUNTED_KEY, merged);
}
